import { Routes, Route } from "react-router-dom";
import './App.css';
// import Dashboard from "./Components/Dashboard/Dashboard";
import Index from "./Components/Home/Index";
import TermsConditions from "./Components/Home/Terms-conditions";
import PrivacyPolicy from "./Components/Home/Privacy-Policy";
// import Stake from "./Components/Dashboard/Stake/Stake";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={< Index />} />
        <Route path="/terms-conditions" element={< TermsConditions />} />
        <Route path="/privacy-policy" element={< PrivacyPolicy />} />

        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>

    </div>
  );
}

export default App;
